import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "flex justify-between py-2"
};
const _hoisted_2 = {
  key: 0,
  class: "pr-2 w-full"
};
const _hoisted_3 = {
  class: "print-only"
};
const _hoisted_4 = {
  key: 1,
  class: "pr-2 w-full"
};
const _hoisted_5 = {
  class: "block mb-2"
};
const _hoisted_6 = {
  class: "border rounded-md overflow-hidden",
  "data-cy": "split-billing-table"
};
const _hoisted_7 = {
  class: "max-h-32 overflow-y-auto"
};
const _hoisted_8 = {
  class: "w-full text-sm",
  "data-cy": "split-billing-details-table"
};
const _hoisted_9 = ["data-cy"];
const _hoisted_10 = ["data-cy"];
const _hoisted_11 = ["data-cy"];
const _hoisted_12 = ["data-cy"];
const _hoisted_13 = {
  class: "w-full text-sm border-t-2",
  "data-cy": "split-billing-total-table"
};
const _hoisted_14 = {
  class: "bg-gray-50 font-medium",
  "data-cy": "split-billing-total-row"
};
const _hoisted_15 = {
  class: "text-right px-3 py-2",
  "data-cy": "split-billing-total-amount"
};
const _hoisted_16 = {
  class: "print-only"
};
const _hoisted_17 = {
  class: "block",
  for: "invoicePdfDescription",
  style: {
    "overflow": "auto",
    "position": "unset"
  }
};
const _hoisted_18 = {
  style: {
    "color": "#555"
  },
  "ui-sref": "settings.company.invoiceEmail",
  href: ""
};
const _hoisted_19 = {
  class: "print-only"
};
import LlTooltip from '@/components/LlTooltip.vue';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
export default {
  __name: 'InvoiceSubHeader',
  props: {
    draftModalState: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      isSaving,
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      setInvoicePdfDescription
    } = useInvoiceState();
    const {
      billto,
      memo,
      invoicePdfDescription,
      isInvoiceDescriptionEnabled,
      client
    } = storeToRefs(useInvoiceState());
    const props = __props;

    // Reactive computed properties for split billing
    const isSplitBilling = computed(() => props.draftModalState.invoice?.isSplitBilling);
    const splitBillingConfig = computed(() => props.draftModalState.invoice?.splitBillingConfig);
    const editMemo = () => {
      props.draftModalState.showMemoModal = true;
    };
    const handleInvoicePdfDescriptionChange = () => {
      setInvoicePdfDescription(invoicePdfDescription.value);
    };
    return (_ctx, _cache) => {
      const _component_v_textarea = _resolveComponent("v-textarea");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!isSplitBilling.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[5] || (_cache[5] = _createElementVNode("label", {
        class: "block",
        for: "billto"
      }, "Bill to", -1)), _createVNode(_component_v_textarea, {
        name: "billto",
        class: "no-print",
        variant: "outlined",
        "hide-details": "true",
        modelValue: _unref(billto).formatted,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(billto).formatted = $event),
        readonly: _unref(onlyViewInvoice) || _ctx.getIsLocked || _unref(isSaving)
      }, null, 8, ["modelValue", "readonly"]), _createElementVNode("pre", _hoisted_3, _toDisplayString(_unref(billto)?.formatted), 1)])) : _createCommentVNode("", true), isSplitBilling.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("label", _hoisted_5, [_cache[6] || (_cache[6] = _createTextVNode("Split Bill ", -1)), _createVNode(LlTooltip, {
        icon: "help"
      }, {
        default: _withCtx(() => [_createTextVNode("To adjust split, go to " + _toDisplayString(_unref(client).label) + " and change percentages", 1)]),
        _: 1
      })]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("table", _hoisted_8, [_createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(splitBillingConfig.value.billDetails, (detail, index) => {
        return _openBlock(), _createElementBlock("tr", {
          key: index,
          class: "border-t",
          "data-cy": `split-billing-row-${index}`
        }, [_createElementVNode("td", {
          class: "px-3 py-2",
          "data-cy": `split-billing-client-name-${index}`
        }, _toDisplayString(detail.clientName), 9, _hoisted_10), _createElementVNode("td", {
          class: "text-right px-3 py-2",
          "data-cy": `split-billing-percentage-${index}`
        }, _toDisplayString(detail.percentage) + "%", 9, _hoisted_11), _createElementVNode("td", {
          class: "text-right px-3 py-2",
          "data-cy": `split-billing-amount-${index}`
        }, " $" + _toDisplayString(detail.amount.toFixed(2)), 9, _hoisted_12)], 8, _hoisted_9);
      }), 128))])])]), _createElementVNode("table", _hoisted_13, [_createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_14, [_cache[7] || (_cache[7] = _createElementVNode("td", {
        class: "px-3 py-2",
        "data-cy": "split-billing-total-label"
      }, "Total", -1)), _cache[8] || (_cache[8] = _createElementVNode("td", {
        class: "text-right px-3 py-2"
      }, null, -1)), _createElementVNode("td", _hoisted_15, " $" + _toDisplayString(splitBillingConfig.value.billDetails.reduce((sum, detail) => sum + detail.amount, 0).toFixed(2)), 1)])])])])])) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["px-2 w-full", {
          'no-print': !_unref(memo)?.memo
        }])
      }, [_cache[9] || (_cache[9] = _createElementVNode("label", {
        class: "block",
        for: "memo"
      }, "Memo", -1)), _createVNode(_component_v_textarea, {
        "data-cy": "memo",
        name: "memo",
        class: "no-print",
        variant: "outlined",
        "hide-details": "true",
        onClick: _cache[1] || (_cache[1] = $event => editMemo()),
        modelValue: _unref(memo).memo,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(memo).memo = $event),
        readonly: _unref(onlyViewInvoice) || _ctx.getIsLocked || _unref(isSaving)
      }, null, 8, ["modelValue", "readonly"]), _createElementVNode("pre", _hoisted_16, _toDisplayString(_unref(memo)?.memo), 1)], 2), _unref(isInvoiceDescriptionEnabled) ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: _normalizeClass(["pl-2 w-full", {
          'no-print': !_unref(invoicePdfDescription)
        }])
      }, [_createElementVNode("label", _hoisted_17, [_cache[11] || (_cache[11] = _createTextVNode("Invoice Description ", -1)), _createElementVNode("a", _hoisted_18, [_createVNode(LlTooltip, {
        icon: "help",
        style: {
          "text-transform": "none"
        }
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("The invoice template applied to this matter has a client facing invoice description enabled. This is different from the memo and will appear above the activity table. Go to Invoice Email Settings to configure further. ", -1)]))]),
        _: 1
      })])]), _createVNode(_component_v_textarea, {
        name: "invoicePdfDescription",
        class: "no-print",
        variant: "outlined",
        "hide-details": "true",
        modelValue: _unref(invoicePdfDescription),
        "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => _isRef(invoicePdfDescription) ? invoicePdfDescription.value = $event : null), _cache[4] || (_cache[4] = $event => handleInvoicePdfDescriptionChange())],
        readonly: _unref(onlyViewInvoice) || _ctx.getIsLocked || _unref(isSaving)
      }, null, 8, ["modelValue", "readonly"]), _createElementVNode("pre", _hoisted_19, _toDisplayString(_unref(invoicePdfDescription)), 1)], 2)) : _createCommentVNode("", true)]);
    };
  }
};